import { useState } from 'react';

const cardItems = [
  {
    title: '动作大片',
    desc: '燃爆肾上腺的动作巨制合集，从东方武侠到西方超级英雄，每一部都让你热血沸腾。',
    icon: 'ri-sword-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20scene%20with%20warm%20dramatic%20lighting%2C%20epic%20battle%20aesthetic%2C%20soft%20coral%20and%20amber%20gradients%2C%20intense%20atmosphere%2C%20rich%20cinematic%20textures%2C%20elegant%20composition&width=600&height=400&seq=cards-01&orientation=landscape'
  },
  {
    title: '悬疑烧脑',
    desc: '精心挑选的高分悬疑片，反转不断、细节满满，考验你的观察力和推理能力。',
    icon: 'ri-search-eye-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20scene%20with%20warm%20shadowy%20lighting%2C%20detective%20noir%20aesthetic%2C%20soft%20coral%20and%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20rich%20film%20textures%2C%20elegant%20composition&width=600&height=400&seq=cards-02&orientation=landscape'
  },
  {
    title: '古装风华',
    desc: '汇聚年度口碑古装大剧，服化道精良、剧情考究，带您领略中华美学盛宴。',
    icon: 'ri-vip-crown-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20historical%20Chinese%20drama%20scene%20with%20warm%20lantern%20lighting%2C%20ancient%20palace%20aesthetic%2C%20soft%20coral%20and%20golden%20gradients%2C%20elegant%20atmosphere%2C%20rich%20silk%20textures%2C%20beautiful%20composition&width=600&height=400&seq=cards-03&orientation=landscape'
  },
  {
    title: '科幻未来',
    desc: '硬核科幻与未来幻想，从时间旅行到外星文明，打开想象力的边界。',
    icon: 'ri-rocket-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20scene%20with%20warm%20futuristic%20lighting%2C%20space%20aesthetic%2C%20soft%20coral%20and%20amber%20nebula%20gradients%2C%20cosmic%20atmosphere%2C%20rich%20cinematic%20textures%2C%20elegant%20composition&width=600&height=400&seq=cards-04&orientation=landscape'
  },
  {
    title: '纪录片库',
    desc: '自然、人文、科技、历史……用镜头探索真实世界的每一个角落，每部都是视觉盛宴。',
    icon: 'ri-earth-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20nature%20scene%20with%20warm%20golden%20hour%20lighting%2C%20vast%20landscape%20aesthetic%2C%20soft%20coral%20sunset%20gradients%2C%20awe-inspiring%20atmosphere%2C%20rich%20natural%20textures%2C%20elegant%20composition&width=600&height=400&seq=cards-05&orientation=landscape'
  },
  {
    title: '动画世界',
    desc: '从国产精品到海外佳作，全年龄段的动画盛宴，治愈、热血、奇幻应有尽有。',
    icon: 'ri-emotion-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20animation%20scene%20with%20warm%20colorful%20lighting%2C%20fantasy%20world%20aesthetic%2C%20soft%20coral%20and%20amber%20gradients%2C%20magical%20atmosphere%2C%20rich%20artistic%20textures%2C%20elegant%20composition&width=600&height=400&seq=cards-06&orientation=landscape'
  },
  {
    title: '高分韩剧',
    desc: '精选近两年口碑最佳的韩剧作品，从浪漫爱情到社会现实，部部精品值得一看。',
    icon: 'ri-heart-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20scene%20with%20warm%20romantic%20lighting%2C%20modern%20aesthetic%2C%20soft%20coral%20and%20amber%20gradients%2C%20intimate%20atmosphere%2C%20rich%20cinematic%20textures%2C%20elegant%20composition&width=600&height=400&seq=cards-07&orientation=landscape'
  },
];

export default function Cards() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">分类导览</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按类型快速找到你想看的内容，七大分类满足不同口味</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.slice(0, 4).map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative aspect-[3/2] bg-background-200 overflow-hidden">
                {!imgErrors[idx] ? (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => setImgErrors((prev) => ({ ...prev, [idx]: true }))}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className={`${item.icon} text-3xl text-foreground-300`}></i>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-7 h-7 rounded-lg bg-primary-500/90 flex items-center justify-center">
                    <i className={`${item.icon} text-sm text-background-50`}></i>
                  </div>
                  <h3 className="font-heading text-base text-background-50">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cardItems.slice(4).map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative aspect-[3/2] bg-background-200 overflow-hidden">
                {!imgErrors[idx + 4] ? (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => setImgErrors((prev) => ({ ...prev, [idx + 4]: true }))}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className={`${item.icon} text-3xl text-foreground-300`}></i>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-7 h-7 rounded-lg bg-primary-500/90 flex items-center justify-center">
                    <i className={`${item.icon} text-sm text-background-50`}></i>
                  </div>
                  <h3 className="font-heading text-base text-background-50">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}